module.exports = __webpack_public_path__ + "img/cnh-icon.6fec6a70.png";